/** The Send email action element. */
import { MetadataEntityFieldEditorType, MetadataEntityFieldType } from '../../../metadata/entity/decorators/model/metadata.entity.field.types';
import { WorkflowActionType } from '../workflow.definition';
import { WorkflowElement, WorkflowFamily, WorkflowFieldOptionSource, WorkflowFieldRenderer, WorkflowSideEffect } from '../workflow.element';

/** Sends a templated email from the run's Job; the template fills whatever the step leaves out. */
export const SEND_JOB_EMAIL_ELEMENT: WorkflowElement = {
    type: WorkflowActionType.SendJobEmail,
    family: WorkflowFamily.Communication,
    sideEffect: WorkflowSideEffect.Send,
    title: 'Send a templated email from the Job',
    icon: 'fa-envelope',
    fields: [
        {
            bind: 'input.templateId',
            required: true,
            optionSource: WorkflowFieldOptionSource.EmailTemplates,
            metadata: {
                displayName: 'Template',
                type: MetadataEntityFieldType.Enum,
            },
        },
        {
            bind: 'input.subject',
            renderer: WorkflowFieldRenderer.MergeText,
            recordTags: true,
            metadata: {
                displayName: 'Subject',
                type: MetadataEntityFieldType.String,
            },
        },
        {
            bind: 'input.body',
            renderer: WorkflowFieldRenderer.MergeText,
            recordTags: true,
            metadata: {
                displayName: 'Body',
                type: MetadataEntityFieldType.String,
                // The full Froala merge editor, as an email template body uses; the other merge-text fields take the one-line input.
                editor: MetadataEntityFieldEditorType.RichText,
            },
        },
        {
            bind: 'input.to',
            renderer: WorkflowFieldRenderer.MergeText,
            metadata: {
                displayName: 'To',
                description: 'Email addresses separated by commas or semicolons',
                type: MetadataEntityFieldType.String,
                // A list of recipients is accepted as well as separated text.
                arrayOf: MetadataEntityFieldType.String,
            },
        },
    ],
    outputs: [
        { path: 'activityId', metadata: { displayName: 'Email ID', type: MetadataEntityFieldType.String } },
    ],
};
